/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

export class CalendarDaySubSection {
  public hour: number;
  public minutes: number;

  public enable = true;
  public selected = false;
  public text: string;

  public backgroundColor = '';

  constructor(hour: number, minutes: number) {
    this.hour = hour;
    this.minutes = minutes;
    this.text =
      (this.hour >= 10 ? this.hour : '0' + this.hour) +
      ':' +
      (this.minutes >= 10 ? this.minutes : '0' + this.minutes);
  }

  public select(select: boolean) {
    if (this.enable) {
      this.selected = select;
    }
  }
}
